module.exports = __webpack_public_path__ + "img/gifta_404_blog.68c429d.jpg";